import { Modal, Table, Button } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { formatCurrency } from 'utils/constants/functions';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  record: any;
}

const DetailEinvoiceHistoryModal: React.FC<IProps> = ({
  isOpen,
  onClose,
  record,
}) => {
  const columns: any[] = [
    {
      title: 'Chi Nhánh',
      dataIndex: 'branchCode',
      width: 100,
      render: (val: string) => val || record?.branchCode || '-',
    },
    {
      title: 'Mã Bill',
      dataIndex: 'billNum',
      width: 120,
      render: (val: string, r: any) =>
        val || r?.billNum || record?.billNum || '-',
    },
    {
      title: 'Số HĐ',
      dataIndex: 'invoiceNumber',
      width: 80,
      render: (val: string) => val || record?.invoiceNumber || '-',
    },
    {
      title: 'Ký Hiệu',
      dataIndex: 'invoiceSerial',
      width: 100,
      render: (val: string) => val || record?.invoiceSerial || '-',
    },
    {
      title: 'Ngày Phát Hành',
      dataIndex: 'publishDate',
      width: 120,
      render: (val: string) => {
        const d = val || record?.publishDate;
        return d ? dayjs(d).format('DD/MM/YYYY') : '-';
      },
    },
    {
      title: 'Giá Trị HĐ',
      dataIndex: 'invoiceAmount',
      width: 120,
      align: 'right',
      render: (val: number) =>
        formatCurrency({ value: val ?? record?.invoiceAmount ?? 0 }),
    },
    {
      title: 'Mã KH',
      dataIndex: 'customerId',
      width: 120,
      render: (val: string) => val || record?.customerId || '-',
    },
    {
      title: 'Tên KH',
      dataIndex: 'customerName',
      width: 160,
      render: (val: string) => val || record?.customerName || '-',
    },
    {
      title: 'Loại KH',
      dataIndex: 'customerType',
      width: 120,
      render: (val: string) => val || record?.customerType || '-',
    },
    {
      title: 'MST',
      dataIndex: 'taxCode',
      width: 120,
      render: (val: string) => val || record?.taxCode || '-',
    },
    {
      title: 'Email',
      dataIndex: 'customerEmail',
      width: 160,
      render: (val: string) => val || record?.customerEmail || '-',
    },
    {
      title: 'SĐT',
      dataIndex: 'customerPhone',
      width: 110,
      render: (val: string) => val || record?.customerPhone || '-',
    },
    {
      title: 'Kênh gửi',
      dataIndex: 'channel',
      width: 100,
      render: (val: string) => val || '-',
    },
    {
      title: 'Hình thức gửi',
      dataIndex: 'sendType',
      width: 120,
      render: (val: string) => (val === 'RESEND' ? 'Gửi lại' : 'Tự động'),
    },
    {
      title: 'Thời gian gửi',
      dataIndex: 'sendTime',
      width: 160,
      render: (val: string, r: any) => {
        const d = val || r?.createdAt;
        return d ? dayjs(d).format('DD/MM/YYYY HH:mm:ss') : '-';
      },
    },
    {
      title: 'Người gửi',
      dataIndex: 'userFullName',
      width: 140,
      render: (val: string) => val || record?.userFullName || '-',
    },
    {
      title: 'Số lần gửi',
      dataIndex: 'sendCount',
      width: 90,
      align: 'center',
      render: (val: number) => val ?? 1,
    },
    {
      title: 'Gửi lại',
      dataIndex: 'resendCount',
      width: 80,
      align: 'center',
      render: (val: number) => val ?? 0,
    },
    {
      title: 'Lý do gửi lại',
      dataIndex: 'resendReason',
      width: 140,
      render: (val: string) => val || '-',
    },
    {
      title: 'Trạng thái gửi',
      dataIndex: 'sendStatus',
      width: 120,
      render: (val: string) => {
        if (val === 'SUCCESS') {
          return <span className="text-green-600 font-medium">Thành công</span>;
        }
        if (val === 'FAILED') {
          return <span className="text-red-500 font-medium">Thất bại</span>;
        }
        return <span className="text-yellow-500 font-medium">Đang xử lý</span>;
      },
    },
    {
      title: 'Thời gian thành công',
      dataIndex: 'successTime',
      width: 160,
      render: (val: string) =>
        val ? dayjs(val).format('DD/MM/YYYY HH:mm:ss') : '-',
    },
    {
      title: 'Thời gian thất bại',
      dataIndex: 'failedTime',
      width: 160,
      render: (val: string) =>
        val ? dayjs(val).format('DD/MM/YYYY HH:mm:ss') : '-',
    },
    {
      title: 'Mã lỗi',
      dataIndex: 'errorCode',
      width: 100,
      render: (val: string) => val || '-',
    },
    {
      title: 'Nội dung lỗi',
      dataIndex: 'errorMessage',
      width: 150,
      render: (val: string) => val || '-',
    },
    {
      title: 'Transaction ID',
      dataIndex: 'transactionId',
      width: 220,
      render: (val: string, r: any) => val || r?.resendRequestId || '-',
    },
    {
      title: 'Link tra cứu',
      dataIndex: 'lookupUrl',
      width: 200,
      render: (val: string) =>
        val ? (
          <a
            href={val}
            target="_blank"
            rel="noreferrer"
            className="text-blue-500 underline truncate block max-w-[200px]"
          >
            {val}
          </a>
        ) : (
          '-'
        ),
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'createdAt',
      width: 160,
      render: (val: string, r: any) => {
        const d = val || r?.createDate || record?.createdAt;
        return d ? dayjs(d).format('DD/MM/YYYY HH:mm:ss') : '-';
      },
    },
    {
      title: 'Người tạo',
      dataIndex: 'createdBy',
      width: 140,
      render: (val: string, r: any) => {
        let u = val || r?.createdBy || record?.userFullName || '-';
        if (u === 'AUTO_CREATE_EINVOICE') {
          u =
            record?.userFullName &&
            record.userFullName !== 'AUTO_CREATE_EINVOICE'
              ? record.userFullName
              : '-';
        }
        return u === 'SAP_CALLBACK' ? 'SAP' : u;
      },
    },
    {
      title: 'Ngày cập nhật',
      dataIndex: 'updatedAt',
      width: 160,
      render: (val: string, r: any) => {
        const d = val || r?.updateDate || record?.updatedAt;
        return d ? dayjs(d).format('DD/MM/YYYY HH:mm:ss') : '-';
      },
    },
    {
      title: 'Người cập nhật',
      dataIndex: 'createdBy',
      width: 140,
      render: (val: string, r: any) => {
        let u = val || r?.createdBy || record?.userFullName || '-';
        if (u === 'AUTO_CREATE_EINVOICE') {
          u =
            record?.userFullName &&
            record.userFullName !== 'AUTO_CREATE_EINVOICE'
              ? record.userFullName
              : '-';
        }
        return u === 'SAP_CALLBACK' ? 'SAP' : u;
      },
    },
  ];

  const dataSource =
    record?.logs && record.logs.length > 0
      ? record.logs
      : record
        ? [record]
        : [];

  return (
    <Modal
      title={
        <span className="text-lg font-bold">
          {`Chi tiết gửi hóa đơn ${record?.invoiceCode ? `- ${record.invoiceCode}` : ''}`}
        </span>
      }
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          Đóng
        </Button>,
      ]}
      width="95vw"
      style={{ top: 20, maxWidth: '95vw' }}
    >
      <div className="overflow-x-auto my-4">
        <Table
          columns={columns}
          dataSource={dataSource}
          rowKey="id"
          pagination={false}
          scroll={{ x: 3800 }}
          bordered
          size="middle"
        />
      </div>
    </Modal>
  );
};

export default DetailEinvoiceHistoryModal;
